export const TYPE = {
  DEL: "DEL",
  COL: "COL"
};
export const DELIVERY_SEARCH = "Delivery Search";
export const COLLECTION_SEARCH = "Collection Search";
export const COLLECTIONS = "Collections";
export const DELIVERIES = "Deliveries";
export const DELIVERY = "Delivery";
export const COLLECTION = "Collection";